import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError } from 'rxjs/operators';
import { APP_SETTINGS } from '../../shared/models/backofficeConfiguration';
import { CacheService } from '../../shared/services/cache.service';
import { ExecuteService } from '../../shared/services/executeService.service';
import { ErrorHandlerService } from '../../shared/services/errorHandler.service';

@Injectable()
export class AssetsService {
  private masterdataApiURL = `${APP_SETTINGS.MasterDataApiUrl}en-US/assetManager/`;

  constructor(private executeService: ExecuteService,
    private errorHandler: ErrorHandlerService,
    private cacheService: CacheService) {
  }

  public GetByFilter(filter: any): any {  
    if (filter == null) {
      return of([]);
    }

    const url = `${this.masterdataApiURL}GetByFilter?`;
    const params = this.getFilterUrlParams(filter);

    return this.executeService.Execute('get', url, params)
      .pipe(
        catchError(this.errorHandler.handleError<object[]>('SearchAssets', []))
      );
  };

  public GetById(id: string): Observable<any> {
    const url = `${this.masterdataApiURL}getById/${id}`;

    return this.executeService.Execute('get', url)
      .pipe(
        catchError(this.errorHandler.handleError<object[]>('GetById assets', []))
      );
  };

  public Create(asset: any): Observable<any> {
    const url = `${this.masterdataApiURL}Create`;
    const body = asset;

    return this.executeService.Execute('post', url, null, body)
      .pipe(
        catchError(this.errorHandler.handleError('CreateAsset', asset))
      );
  };

  public Edit(asset: any): Observable<any> {
    const url = `${this.masterdataApiURL}Edit`;
    const body = asset;

    return this.executeService.Execute('put', url, null, body)
      .pipe(
        catchError(this.errorHandler.handleError('EditAsset', asset))
      );
  };

  public Deactivate(assetId: string) {
    const url = `${this.masterdataApiURL}Deactivate/${assetId}`;

    return this.executeService.Execute('delete', url)
      .pipe(
        catchError(this.errorHandler.handleError<any>('DeactivateAsset'))
      );
  };

  GetAssetsWithCalculation(): Observable<any> {
    const url = `${APP_SETTINGS.MarketToolI3ApiUrl}/v1/en-US/lastcandle/assets/`;

    return this.cacheService.get('getAssetsWithCalculation', this.executeService.ExecuteWithLocalAccessToken('get', url)
      .pipe(
        catchError(this.errorHandler.handleError<object[]>('AssetsCalculation', []))
      ));
  };

  public GetProviders(): Observable<any[]> {
    const url = `${this.masterdataApiURL}GetProviders/`;

    return this.cacheService.get(
      'providers',
      this.executeService.Execute('get', url)
        .pipe(
          catchError(this.errorHandler.handleError<object[]>('GetProviders', []))
        ));
  };


  private getFilterUrlParams(filter: any): any {
    let result = new HttpParams();

    if (filter.name) { result = result.set('name', filter.name); }
    if (filter.providerId) { result = result.set('providerId', filter.providerId); }
    if (filter.type) { result = result.set('type', filter.type); }
    if (filter.isActive) { result = result.set('isActive', filter.isActive); }
    if (filter.isFollow) { result = result.set('isFollow', filter.isFollow); }
    if (filter.providerCode) { result = result.set('providerCode', filter.providerCode); }
    return result;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/assets.service.ts